import { InsertableOptions } from '@aceable/core';
import type { OnInit } from '@angular/core';
import { ComponentFactoryResolver, Directive, Input, ViewContainerRef } from '@angular/core';
import { ComponentRegistry } from '../component-registry';
import type { Insertable } from '../insertable';

@Directive({
  selector: '[aceInsertableHost]',
  standalone: true,
})
export class InsertableHostDirective implements OnInit {
  @Input() options?: InsertableOptions;
  @Input() registry: ComponentRegistry;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private readonly componentFactoryResolver: ComponentFactoryResolver,
  ) {}

  ngOnInit(): void {
    this.viewContainerRef.clear();
    const componentName = this.options.className;
    const componentType = this.registry.lookup(componentName);
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);
    const componentRef = this.viewContainerRef.createComponent(componentFactory);
    const panel: Insertable = componentRef.instance;
    panel.data = this.options.data;
  }
}
